import { forwardRef, type ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

/** Shared top-level page title, matching the dashboard welcome header. */
export const PageHeader = forwardRef<
  HTMLHeadingElement,
  { title: ReactNode; subtitle?: ReactNode; actions?: ReactNode }
>(function PageHeader({ title, subtitle, actions }, ref) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      gap={2}
      justifyContent="space-between"
      alignItems={{ md: 'flex-end' }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          ref={ref}
          tabIndex={ref ? -1 : undefined}
          variant="h3"
          component="h1"
          sx={{ fontWeight: 700, outline: 'none' }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          sx={{ flexShrink: 0 }}
        >
          {actions}
        </Stack>
      )}
    </Stack>
  );
});
